import { states } from '@/../shared/store/modules/states'

export const state = () => ({ states: [] })
export const mutations = states.mutations
export const getters = states.getters
export const actions = states.actions